export const isUndefined = (maybeObject: any): maybeObject is undefined => typeof maybeObject === "undefined";
